export const isEmptyString = (str?: string) => !str?.trim()?.length;
